import React from 'react';
import { useStaffStatus } from '../../contexts';
import { TabType } from './Main';

import './TabNav.css';

const AlertTabButton: React.FC<{
    active: boolean;
    onClick: () => void;
    showAlert?: boolean;
    children: React.ReactNode,
  }> = ({ active, onClick, showAlert=false, children }) => {
    return (
      <button 
        className={`tab-button ${active ? 'active' : ''} ${showAlert ? 'pulse-warning' : ''}`}
        onClick={onClick}
      >
        <span className='label'>{children}</span>
        {showAlert && <span className="alert-icon"></span>}
        <span className='tabnav-tooltip'>{children}</span>
      </button>
    );
  };

interface TabNavProps {
    activeTab: string;
    setActiveTab: (tab: TabType) => void;
    hasUnderstaffedClassrooms: boolean;
    children: React.ReactNode;
}

const TabNav:React.FC<TabNavProps> = ({
    activeTab,
    setActiveTab,
    hasUnderstaffedClassrooms,
    children
}) => {
    const { missingClockins, missingCheckins } = useStaffStatus();
    const showStaffAlert = missingClockins > 0 || missingCheckins > 0;

    return (
        <div className={`tab-nav-component ${activeTab == 'historical' ? 'full-width' : ''}`}>
            <div className="tab-buttons">
                <AlertTabButton 
                    active={activeTab === 'classrooms'}
                    onClick={() => setActiveTab('classrooms')}
                    showAlert={hasUnderstaffedClassrooms}
                >
                    Classroom Summary
                </AlertTabButton>
                <AlertTabButton 
                    active={activeTab === 'staff'}
                    onClick={() => setActiveTab('staff')}
                    showAlert={showStaffAlert}
                >
                    Missing Checkins / Clockins
                </AlertTabButton>
                <AlertTabButton  
                    active={activeTab ===  'details'}
                    onClick={() => setActiveTab('details')}

                >
                    Classroom Details
                </AlertTabButton>
                <AlertTabButton
                    active={activeTab ===  'historical'}
                    onClick={() => setActiveTab('historical')}
                >
                    Historical Ratios
                </AlertTabButton>
            </div>
            <div className="tab-content">
                {children}
            </div>
        </div>
    );
};
export default TabNav;